// Bootstrap that registers all per-key wizard React components into the
// deprecation registry. Imported once from src/index.js so the
// MigrationWizardModal can find a custom wizard for keys that have one.

import { registerWizardComponent } from './registry';
import AdminGeoMapMigrationWizard from '../../pages/admin/AdminGeoMapMigrationWizard';

registerWizardComponent(
  'geoguesser.map_needs_floor_review',
  AdminGeoMapMigrationWizard,
  { title: 'Confirm map floor layout' },
);
